import {License} from "../../const/license";
import {FeatureAccessMatrix} from "./access-matrix";
import {Feature, FeatureAccessRules} from "./const";
import {LicenseType} from "../../license/license-proto";

// const debug = "featureAccess"
const debug = false

export function featureAccess(feature:string | Feature):boolean {

    debug && console.log(debug, "check ", feature)

    const rules : FeatureAccessRules = _.get(FeatureAccessMatrix, feature)

    if (!rules) {
        console.error("ERROR #feature-access-1 No rule for feature found", feature)
        return false
    }

    const companyLicense = gd.company.license.license || License.FREE

    debug && console.log(debug, "check companyLicense", companyLicense)

    if (rules.enabled) {
        debug && console.log(debug, "based on rules.enabled")
        if (rules.enabled.includes(companyLicense)) {
            return true
        } else {
            return false
        }
    }

    if (rules.disabled) {
        debug && console.log(debug, "based on rules.disabled")
        if (rules.disabled.includes(companyLicense)) {
            return false
        } else {
            return true
        }
    }


    console.error("Rules missing #9384040-223 ")

    return false


}


export function featureRequiredLicenseType(feature:Feature):LicenseType {

    const rules : FeatureAccessRules | false = feature? getRules(feature) : false

    if (!rules) return LicenseType.Pro

    return rules.requiredLicenseType || LicenseType.Pro
}

export function featureRequiredLicenseName(feature: Feature) {
    const requiredLicenseType: LicenseType = featureRequiredLicenseType(feature)


    switch (requiredLicenseType) {
        case LicenseType.Business:
            return 'Business'
        default:
            return 'Professional'
    }

}


function getRules(feature:string) {

    const rules : FeatureAccessRules = _.get(FeatureAccessMatrix, feature)

    if (!rules) {
        console.warn("ERROR #feature-access-1 No rule for feature found", feature)
        return false
    }

    return rules
}